<template>
    <div class="jump-usercenter nav-bar-fixed">
        <van-nav-bar title="个人资料" left-arrow fixed @click-left="back"/>

        <van-field
                label="用户名称"
                :value="userinfo.userName"
                readonly
        />
        <van-field
                v-model="phone"
                label="手机号码"
                readonly
        >
            <van-button slot="button" size="small" type="primary" @click="userMobile">修改</van-button>
        </van-field>
      <!--  <van-field
                v-model="smscode"
                label="电子邮箱"
                placeholder="请输入正确的邮箱格式">
            &lt;!&ndash;<van-button slot="button" size="small" type="primary">修改</van-button>&ndash;&gt;
        </van-field>-->

        <van-field
                label="可用积分"
                :value="userinfo.integral"
                readonly
        />
        <van-field
                v-model="username"
                label="姓名"
                value="未填写"
        />
        <van-radio-group v-model="radio">
            <van-cell-group>
                <van-cell title="性别">
                    <van-radio name="-1">保密</van-radio>
                    <van-radio name="1">男</van-radio>
                    <van-radio name="0">女</van-radio>
                </van-cell>
            </van-cell-group>
        </van-radio-group>

        <van-field
                :value="birthday"
                label="出生日期"
                placeholder="请选择"
                @focus="showDate"
                readonly
        />

        <van-field
                :value="addressPCS"
                label="所在地"
                placeholder="请选择省/市/区"
                @focus="showPop"
        />

        <van-popup v-model="popDateShow" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    @cancel="popDateShow = false"
                    @confirm="onDateConfirm"
                    :formatter="formatter"
                    :max-date="maxDate"
                    :min-date="minDate"
            />
        </van-popup>

        <van-popup v-model="popPickerShow" position="bottom" :overlay="true">
            <van-picker
                    :columns="columns"
                    show-toolbar
                    value-key="areaName"
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
            />
        </van-popup>
        <van-field
                v-model="qq"
                label="QQ号码"
        />
            <!--<van-button slot="button" size="small" type="primary">修改</van-button>-->
        </van-field>
        <div class="usercenter-button">
            <van-button size="large" @click="save">提 交</van-button>
        </div>
    </div>
</template>
<script>
    import {
        NavBar,
        Row,
        Col,
        Field,
        Button,
        Popup,
        Picker,
        Cell,
        CellGroup,
        RadioGroup,
        Radio,
        DatetimePicker
    } from "vant";

    var citys = [];
    var country = {}
    var xjq = {}

    export default {
        name: "userinfo",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [DatetimePicker.name]: DatetimePicker
        },
        data() {
            return {
                userinfo:{},
                radio: "1",
                currentDate: new Date(),
                popDateShow: false,
                popPickerShow: false,
                columns: [
                    {
                        values: citys,
                        className: 'column1',
                        defaultIndex: 0
                    },
                    {
                        values: country['北京市'],
                        className: 'column2',
                        defaultIndex: 1
                    }
                    ,
                    {
                        values: xjq['北京市'],
                        className: 'column3',
                        defaultIndex: 2
                    }
                ],
                addressPCS: "",
                birthday: "",
                phone: "",
                smscode: "",
                username:'',
                qq: "",
                addId: '',
                maxDate:new Date(),
                minDate: new Date(1900, 1, 1),
            };
        }, 
        mounted() {
            this.getUserInfo()
            this.getAreaList()
        },
        methods: {
            showDate() {
                this.popDateShow = true;
            },
            showPop() {
                this.popPickerShow = true;
            },
            onPickerCancel() {
                this.popPickerShow = false;
            },
            onPickerConfirm(values) {
                var that = this;
                that.addressPCS = values[0].areaName + ' ' + values[1].areaName + ' ' + values[2].areaName;
                this.addId = values[2].id
                this.popPickerShow = false;
            },
            onPickerChange(picker, values, defaultIndex) {
                let ss
                let that = this
                if (defaultIndex == 0) {
                    that.$api.post(
                        that.jumuc.userCenter.areaList,
                        {"parent_id": values[0].id},
                        successRes => {
                            ss = successRes.data[0].areaName
                            country[values[0].areaName] = successRes.data
                            that.$api.post(
                                that.jumuc.userCenter.areaList,
                                {"parent_id": successRes.data[0].id},
                                successRes => {
                                    xjq[ss] = successRes.data
                                    that.columns = [
                                        {
                                            values: citys,
                                            className: 'column1',
                                            defaultIndex: 0
                                        },
                                        {
                                            values: country[values[0].areaName],
                                            className: 'column2',
                                            defaultIndex: 1
                                        }
                                        ,
                                        {
                                            values: xjq[ss],
                                            className: 'column3',
                                            defaultIndex: 2
                                        }
                                    ]
                                    picker.setColumnValues(1, country [values[0].areaName]);
                                    picker.setColumnValues(2, xjq [values[1].areaName]);
                                })
                        })
                }
                if (defaultIndex == 1) {
                    that.$api.post(
                        that.jumuc.userCenter.areaList,
                        {"parent_id": values[1].id},
                        successRes => {
                            xjq[ss] = successRes.data
                            that.columns = [
                                {
                                    values: citys,
                                    className: 'column1',
                                    defaultIndex: 0
                                },
                                {
                                    values: country[values[0].areaName],
                                    className: 'column2',
                                    defaultIndex: 1
                                }
                                ,
                                {
                                    values: xjq[ss],
                                    className: 'column3',
                                    defaultIndex: 2
                                }
                            ]
                            picker.setColumnValues(2, xjq [values[1].areaName]);
                        })
                }
                // picker.setColumnValues(1, citys[values[0]]);
            }, 
            getAreaList(id) {
                let that = this
                let aa
                let ss
                //省
                that.$api.post(
                    that.jumuc.userCenter.areaList,

                    {"parent_id": id},
                    successRes => {
                        citys = successRes.data
                        aa = successRes.data[0].areaName
                        //市
                        that.$api.post(
                            that.jumuc.userCenter.areaList,
                            {"parent_id": citys[0].id},
                            successRes => {
                                country[citys[0].areaName] = successRes.data
                                ss = successRes.data[0].areaName
                                //县/区
                                that.$api.post(
                                    that.jumuc.userCenter.areaList,
                                    {"parent_id": successRes.data[0].id},
                                    successRes => {
                                        xjq[ss] = successRes.data
                                        that.columns = [
                                            {
                                                values: citys,
                                                className: 'column1',
                                                defaultIndex: 0
                                            },
                                            {
                                                values: country[aa],
                                                className: 'column2',
                                                defaultIndex: 1
                                            }
                                            ,
                                            {
                                                values: xjq[ss],
                                                className: 'column3',
                                                defaultIndex: 2
                                            }
                                        ]
                                    })
                            })
                    })
            }, 
            userMobile() {
                this.$router.push({"path": "/user/usermobile"})
            },
            onDateConfirm(value) {
                const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
               // const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
                 this.birthday = resDate;
                this.popDateShow = false;
            }, p(s) {
                return s < 10 ? '0' + s : s
            },
            formatter(type, value) {
                if (type === 'year') {
                    return `${value}年`;
                } else if (type === 'month') {
                    return `${value}月`
                } else if (type === 'day') {
                    return `${value}日`
                }
                return value;
            },
            back() {
                history.back();
            }, 
            getUserInfo() {
                let that = this
                that.$api.get(that.jumuc.userCenter.getUserInfo,null,
                successRes => {
                    that.userinfo = successRes.data.user
                    that.phone=that.userinfo.mobile
                    that.username=that.userinfo.trueName
                    that.radio=that.userinfo.sex+''
                    that.addressPCS=successRes.data.areaPath
                    that.qq=that.userinfo.qq
                    let str=that.userinfo.birthday;
                    that.birthday=str.substring(0,10)
                })
            },save(){
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.saveUserInfo,
                    {"trueName":that.username,"sex":that.radio,"birthday":that.birthday,"cityId":that.addId,"qq":that.qq},
                    successRes => {
                        that.$toast(successRes.msg);
                        if (successRes.success) {
                            that.$router.push({"path": "/usercent"})
                        }
                    })
            }

        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    .jump-usercenter {
        padding-top: 50px;
        button {
            background-color: @bule-thame;
            border-color: @bule-thame;
        }
        .usercenter-button {
            padding: 0 15px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }

        .van-radio-group {
            .van-cell__title {
                max-width: 90px;
            }
            .van-cell__value {
                text-align: left;
                .van-radio {
                    display: inline-block;
                    margin-right: 15px;
                }
            }
        }
    }
</style>

